// SalaDePrensaPrensa.js
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import PrensaModal from './PrensaModal';
import boletinesData from './boletinesData.js';

function SalaDePrensaPrensa() {
  const [showModal, setShowModal] = useState(false);
  const [boletinSeleccionado, setBoletinSeleccionado] = useState(null);

  const handleShow = (item) => {
    setBoletinSeleccionado(item);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setBoletinSeleccionado(null);
  };

  return (
    <Container className="mt-5">
      <h2 className="text-center mb-4">Sala de Prensa</h2>
      <Row xs={1} md={3} className="g-4">
        {boletinesData.map(item => (
          <Col key={item.id}>
            <Card className="shadow-sm h-100">
              <Card.Img variant="top" src={item.imagen} alt={item.titulo} />
              <Card.Body>
                <Card.Subtitle className="mb-2 text-muted">{item.fecha}</Card.Subtitle>
                <Card.Title>{item.titulo}</Card.Title>
                <Card.Text>{item.resumen}</Card.Text>
                <Button variant="primary" onClick={() => handleShow(item)}>Leer más</Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <PrensaModal show={showModal} handleClose={handleClose} data={boletinSeleccionado} />
    </Container>
  );
}

export default SalaDePrensaPrensa;
